export default __webpack_public_path__ + "static/media/OnboardingPicture.bebc000d.jpeg";